import { AgGridReact } from 'ag-grid-react';
import { ColDef, LicenseManager } from 'ag-grid-enterprise';
import { AG_GRID_LICENSE } from '../../constants';
import { useMemo, useRef } from 'react'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { CommonDropdown } from "../UnifyAdministration/Blocks/AdminCommonSelector"
import { GroupBodyContainer, GroupPaneMain, GroupTitleBar, StyledTableWrapper, StyledTableContainer } from './StyledComponents';
import { useTranslation } from 'react-i18next';
import { IGroupListItem } from './interface';

LicenseManager.setLicenseKey(AG_GRID_LICENSE);

export default function GroupingPane({ userList, onGroupChange, onUserSelect, selectedView }: 
  { 
    userList:IGroupListItem[], 
    onGroupChange: Function
    onUserSelect: Function,
    selectedView: { label: string, value: string } }) {

const gridRef = useRef<AgGridReact>(null);

const {t} = useTranslation();
 
 const onGroupSelect = (option: any) => {
    onGroupChange(option);
 }
 const cellClickedListener = (rowData:any) => {
  onUserSelect(rowData.data?.loginId, rowData.data?.groupId);
 }
 
 const enableTreeData = true;
  const getDataPath = (data:IGroupListItem) => data.path ;
  const autoGroupColumnDef = useMemo<ColDef>(() => {
    return {
      headerName: "Group Name",
      minWidth: 280,
      cellRendererParams: {
        suppressCount: true,
      },
    };
  }, []);
  return (
    <GroupPaneMain>
        <GroupTitleBar>
          <div style={{marginTop: '15px'}}>{t('pulse.selectview')}</div>
          <div><CommonDropdown
                  options={[
                    { label: t('pulse.all'), value: 'ALL' },
                    { label: t('pulse.ip'), value: 'IP' },
                    { label: t('pulse.store'), value: 'STORE' }
                  ]}
                  name="pulse-menu-group"
                  label=""
                  placeholder=""
                  selectedOption={selectedView}
                  onSelect={onGroupSelect} /></div>
        </GroupTitleBar>
        <GroupBodyContainer>
            { 
               <StyledTableContainer>
                  <StyledTableWrapper hideHeader={true} className="ag-theme-alpine">
                    <AgGridReact 
                      ref={gridRef}
                      rowData={userList}
                      treeData={enableTreeData}
                      getDataPath={getDataPath}
                      autoGroupColumnDef={autoGroupColumnDef}
                      groupDefaultExpanded={0}
                      columnDefs={[]}
                      defaultColDef={
                        {
                          enablePivot: true,
                          sortable: false,
                          filter: false,
                          autoHeight: true,
                          resizable: false,
                        }
                      }
                      animateRows={true}
                      rowSelection="single"
                      onCellClicked={cellClickedListener}
                      excludeHiddenColumnsFromQuickFilter={true}
                      suppressDragLeaveHidesColumns={true} />  
                    </StyledTableWrapper> 
                  </StyledTableContainer>
            }
        </GroupBodyContainer>
    </GroupPaneMain>
  )
}
